import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useTranslate } from 'react-admin';
import useCategories from '../hooks/useCategories';

const CategoryFilterInput = (props) => {
  const translate = useTranslate();
  const categories = useCategories();

  return (
    <Select
      variant="standard"
      size="small"
      value={props.item.value || ''}
      onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
      displayEmpty
      fullWidth
      sx={{ minWidth: 160 }}
    >
      <MenuItem value="" disabled>
        {translate('filters.select_category', { _: 'Select category' })}
      </MenuItem>
      {categories.map((category) => (
        <MenuItem key={category.id} value={category.id}>
          {category.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CategoryFilterInput;
